import React, { createContext, useCallback, useContext, useState } from 'react';
import { HojaPlus, MotivoOferta } from '../components/plus/HojaPlus';
import { LimiteAlcanzado } from '../config/planes';

/**
 * Abre la hoja de myarinn Plus desde cualquier sitio: al pulsar «Nueva…» con
 * el tope alcanzado (ver useLimite), al entrar en Préstamos sin Plus o desde
 * Configuración. Llegar a un límite nunca es un error, es esta hoja.
 */
interface PlusContextType {
  ofrecerPlus: (motivo?: MotivoOferta) => void;
  /** Si `e` es un LimiteAlcanzado, abre la hoja y devuelve true. */
  ofrecerSiEsLimite: (e: unknown) => boolean;
}

const PlusContext = createContext<PlusContextType | undefined>(undefined);

export const PlusProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [abierta, setAbierta] = useState<{ motivo: MotivoOferta } | null>(null);

  const ofrecerPlus = useCallback((motivo?: MotivoOferta) => setAbierta({ motivo }), []);
  const ofrecerSiEsLimite = useCallback((e: unknown) => {
    if (!(e instanceof LimiteAlcanzado)) return false;
    setAbierta({ motivo: e.clave });
    return true;
  }, []);

  return (
    <PlusContext.Provider value={{ ofrecerPlus, ofrecerSiEsLimite }}>
      {children}
      {abierta && <HojaPlus motivo={abierta.motivo} onClose={() => setAbierta(null)} />}
    </PlusContext.Provider>
  );
};

export const usePlus = () => {
  const ctx = useContext(PlusContext);
  if (!ctx) throw new Error('usePlus debe usarse dentro de PlusProvider');
  return ctx;
};
